import { InvalidateQueryFilters, useQuery, useQueryClient } from '@tanstack/react-query'
import { getEvents } from 'api/event'
import { useState } from 'react'

export const useEventsUser = () => {
    const [searchTerm, setSearchTerm] = useState('')
    const queryClient = useQueryClient()

    const handleSearch = (value: string) => {
        setSearchTerm(value)
        queryClient.invalidateQueries(['events'] as InvalidateQueryFilters)
    }

    const { data, isLoading, error } = useQuery({
        queryKey: ['events', searchTerm],
        queryFn: () => getEvents(searchTerm),
    })

    return {
        data,
        isLoading,
        error,
        handleSearch,
    }
}
